import { Capacitor } from '@capacitor/core';

console.log('VUE_APP_NODE_ENV:', process.env.VUE_APP_NODE_ENV);
console.log('LOCALE:', process.env.VUE_APP_I18N_LOCALE);
console.log('HTTPS:', process.env.HTTPS);
// Use origin-relative URLs so the API works on any domain (tolspor.is, golfspor.is, golf.localhost, etc.)
// Nginx proxies /api/ and /golfapi/ on all server blocks to the same backend.
let apiUrl = window.location.origin + "/api";
switch (process.env.VUE_APP_NODE_ENV) {
	case "development":
		apiUrl = window.location.origin + "/api";
    //apiUrl = "https://192.168.8.142:7123/api";
		break;
	case "aws-development":
		apiUrl = window.location.origin + "/api";
		break;
	case "aws-production":
		apiUrl = window.location.origin + "/api";
		break;
	default:
		console.error("VUE_APP_NODE_ENV not set, using developments api urls");
		//apiUrl = "https://192.168.1.12:7123/api";  // or set to prod or awsDev as per your requirement
    apiUrl = window.location.origin + "/api";
		break;
}
// Native iOS app (Capacitor): the page origin is capacitor://localhost, so API calls and
// QR/export URLs must target the real site. Brand and environment are fixed at build time.
const isNative = Capacitor.isNativePlatform();
const nativeOrigin = 'https://' +
  (process.env.VUE_APP_NODE_ENV === 'aws-production' ? '' : 'dev.') +
  (process.env.VUE_APP_BRAND === 'golfspor' ? 'golfspor.is' : 'tolspor.is');
if (isNative) {
  apiUrl = nativeOrigin + "/api";
}
const golfApiUrl = apiUrl.replace(/\/api$/, '/golfapi');

export default {
  apiUrl: apiUrl,
  golfApiUrl: golfApiUrl,
  baseUrl: isNative ? nativeOrigin : window.location.origin,
  // iOS drops Secure cookies on capacitor://localhost (not https). In the native app the
  // cookie never leaves the device, so the flag is only needed on the web.
  secureCookies: !isNative,
  colors: {
    default: '#344675',
    primary: '#42b883',
    info: '#1d8cf8',
    danger: '#fd5d93',
    orange: '#ff8a76',
    teal: '#00d6b4',
    primaryGradient: [
      'rgba(76, 211, 150, 0.1)',
      'rgba(53, 183, 125, 0)',
      'rgba(119,52,169,0)'
    ],
    purpleGradient: ['rgba(253,93,147,0.8)', 'rgba(253,93,147,0)']
  }
};
